/**
 * BlockedUserScreen - Displayed when a user's account has been blocked
 * Feature: User blocking implementation
 */
import { useClerk } from '@clerk/clerk-react';
import { ShieldX } from 'lucide-react';

export function BlockedUserScreen() {
  const { signOut } = useClerk();

  const handleSignOut = async () => {
    await signOut();
    // After signOut, Clerk will redirect to the sign-in page
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mb-6">
          <ShieldX className="w-10 h-10 text-red-500" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-white mb-3">
          Account Blocked
        </h1>

        {/* Message */}
        <p className="text-gray-400 mb-8">
          Your account has been blocked by an administrator.
          If you believe this is a mistake, please contact support for assistance.
        </p>

        {/* Sign Out Button */}
        <button
          onClick={handleSignOut}
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
        >
          Sign Out
        </button>

        {/* Support Link */}
        <p className="mt-6 text-sm text-gray-500">
          Need help?{' '}
          <a
            href="mailto:support@intelligentia.ca"
            className="text-blue-400 hover:text-blue-300 underline"
          >
            Contact Support
          </a>
        </p>
      </div>
    </div>
  );
}
